import { render, staticRenderFns } from "./EmailClientComponent.vue?vue&type=template&id=2005dc06&scoped=true&"
import script from "./EmailClientComponent.vue?vue&type=script&lang=js&"
export * from "./EmailClientComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2005dc06",
  null
  
)

export default component.exports